export default __webpack_public_path__ + "static/media/sessoes_orientacao.12ef4eef.jpg";